import(/* webpackMode: "eager", webpackExports: ["StylesProvider"] */ "/home/runner/work/monorepo/monorepo/react-native/next/app/(main)/_/components/styles-provider.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/react-native/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/react-native/node_modules/react-notion-x/src/styles.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/react-native/next/app/(main)/(informational)/(notion)/_css/notion.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/monorepo/monorepo/react-native/src/icons/IconLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/monorepo/monorepo/react-native/src/screens/(informational)/components/InformationalContentWrapper/components/InformationalFooter/InformationalFooter.web.tsx");
